import React, { useEffect, useState } from "react";
import Card from "../components/Card";
import Button from "../components/Button";
import API from "../api/api";

const PERIODOS = {
  dia: 1,
  mes: 30,
  anho: 365,
};

function getDiasAlVencimiento(vencimiento) {
  if (!vencimiento) return 1;
  const hoy = new Date();
  const fechaVenc = new Date(vencimiento);
  const diffMs = Math.abs(
    fechaVenc.setHours(0, 0, 0, 0) - hoy.setHours(0, 0, 0, 0)
  );
  return Math.max(1, Math.ceil(diffMs / (1000 * 60 * 60 * 24)));
}

function calcularOfertaSugerida(monto, vencimiento, porcentaje, periodo) {
  const montoBase = Number(monto || 0);
  const porcentajeBase = Number(porcentaje || 0);

  if (!montoBase || !porcentajeBase || !PERIODOS[periodo]) {
    return {
      dias: getDiasAlVencimiento(vencimiento),
      descuentoPct: 0,
      descuentoMonto: 0,
      montoSugerido: montoBase,
    };
  }

  const dias = getDiasAlVencimiento(vencimiento);
  const factorPeriodo = dias / PERIODOS[periodo];
  const descuentoPct = (porcentajeBase / 100) * factorPeriodo;
  const descuentoMonto = montoBase * descuentoPct;
  const montoSugerido = Math.max(0, montoBase - descuentoMonto);

  return { dias, descuentoPct, descuentoMonto, montoSugerido };
}

export default function PublicacionesComprador() {
  const [publicaciones, setPublicaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [enviando, setEnviando] = useState(false);
  const [montoOferta, setMontoOferta] = useState({}); // { pubId: monto }
  const [porcentajeCalculadora, setPorcentajeCalculadora] = useState({});
  const [periodoCalculadora, setPeriodoCalculadora] = useState({});


  const usuario = JSON.parse(localStorage.getItem("usuario"));




  const cargarPublicaciones = async () => {
    try {
      const res = await API.get("/publicaciones/");
      const pubsActivas = res.data;


      const pubsConMiOferta = await Promise.all(
        pubsActivas.map(async (pub) => {
          const r = await API.get(`/ofertas/publicacion/${pub.id}/`);
          const ofertas = r.data;

          const miOferta = ofertas.find(
            (o) => o.comprador === usuario.id
          );

          return {
            ...pub,
            miOferta: miOferta || null,
          };
        })
      );

      setPublicaciones(pubsConMiOferta);
    } catch (err) {
      console.error("Error cargando publicaciones", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarPublicaciones();
  }, []);


  // CREAR OFERTA

  const enviarOferta = async (pubId) => {
    const monto = montoOferta[pubId];
    if (!monto || monto <= 0) {
      alert("Ingrese un monto válido");
      return;
    }

    if (!usuario || !usuario.id) {
      alert("No hay usuario logueado");
      return;
    }

    setEnviando(true);

    try {
      await API.post("/ofertas/crear/", {
        publicacion: pubId,
        monto: Number(monto),
        comprador: usuario.id,
        comentario: "",
      });

      alert("Oferta enviada con éxito");

      cargarPublicaciones();
    } catch (err) {
      console.error(err);
      alert(
        err.response?.data?.detail ||
          err.response?.data?.error ||
          "Error enviando la oferta"
      );
    } finally {
      setEnviando(false);
    }
  };

  if (loading)
    return <p className="text-center text-primary mt-10">Cargando...</p>;

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-primary">Publicaciones disponibles</h1>

      {publicaciones.length === 0 ? (
        <p className="text-slate-500">No hay publicaciones activas.</p>
      ) : (
        publicaciones.map((pub) => (
          <Card key={pub.id} className="space-y-4">
            {/* CABECERA */}
            <div>
              <h2 className="text-lg font-semibold text-primary">{pub.titulo}</h2>

              <p className="text-sm text-slate-600">
                Tipo: <span className="capitalize">{pub.tipo}</span>
              </p>

              <p className="text-sm text-slate-600">
                Monto solicitado:{" "}
                <b>{Number(pub.monto).toLocaleString("es-PY")} Gs</b>
              </p>

              <p className="text-sm text-slate-600">
                Estado:{" "}
                <b
                  className={`capitalize ${
                    pub.estado === "activo"
                      ? "text-emerald-600"
                      : pub.estado === "pendiente"
                      ? "text-amber-600"
                      : "text-red-600"
                  }`}
                >
                  {pub.estado}
                </b>
              </p>
            </div>

            {/* ARCHIVOS ADJUNTOS */}
            {pub.archivos_adjuntos.length > 0 && (
              <div>
                <h3 className="font-semibold text-primary text-sm mb-2">
                  Archivos adjuntos
                </h3>
                {pub.archivos_adjuntos.map((adj) => (
                  <a
                    key={adj.id}
                    href={adj.archivo}
                    target="_blank"
                    className="text-blue-600 underline text-sm block"
                  >
                    {adj.nombre}
                  </a>
                ))}
              </div>
            )}

            {/* MI OFERTA */}
            {pub.miOferta ? (
              <div className="p-3 bg-emerald-50 border rounded">
                <p className="text-sm">
                  Ya ofertaste:{" "}
                  <b>
                    {Number(pub.miOferta.monto).toLocaleString("es-PY")} Gs
                  </b>
                </p>

                <p
                  className={`text-xs font-semibold mt-1 ${
                    pub.miOferta.estado === "aceptada"
                      ? "text-emerald-700"
                      : pub.miOferta.estado === "rechazada"
                      ? "text-red-600"
                      : "text-amber-600"
                  }`}
                >
                  Estado: {pub.miOferta.estado}
                </p>
              </div>
            ) : (
              // FORMULARIO PARA OFERTAR
              <div className="space-y-3">
                {(() => {
                  const calculo = calcularOfertaSugerida(
                    pub.monto,
                    pub.vencimiento,
                    porcentajeCalculadora[pub.id],
                    periodoCalculadora[pub.id] || "mes"
                  );

                  return (
                    <div className="p-3 border rounded bg-slate-50 space-y-3">
                      <h3 className="font-semibold text-primary text-sm">
                        Calculadora de oferta
                      </h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                        <input
                          type="number"
                          step="0.01"
                          placeholder="Porcentaje"
                          className="border p-2 rounded w-full"
                          value={porcentajeCalculadora[pub.id] || ""}
                          onChange={(e) =>
                            setPorcentajeCalculadora({
                              ...porcentajeCalculadora,
                              [pub.id]: e.target.value,
                            })
                          }
                        />
                        <select
                          className="border p-2 rounded w-full"
                          value={periodoCalculadora[pub.id] || "mes"}
                          onChange={(e) =>
                            setPeriodoCalculadora({
                              ...periodoCalculadora,
                              [pub.id]: e.target.value,
                            })
                          }
                        >
                          <option value="dia">Por día</option>
                          <option value="mes">Por mes</option>
                          <option value="anho">Por año</option>
                        </select>
                      </div>
                      <p className="text-xs text-slate-600">
                        Días al vencimiento: {calculo.dias} | Descuento estimado: {(calculo.descuentoPct * 100).toFixed(2)}%
                      </p>
                      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                        <p className="text-sm">
                          Oferta sugerida: <b>Gs {Math.round(calculo.montoSugerido || 0).toLocaleString("es-PY")}</b>
                        </p>
                        <Button
                          className="bg-slate-700 hover:bg-slate-800"
                          onClick={() =>
                            setMontoOferta({
                              ...montoOferta,
                              [pub.id]: Math.round(calculo.montoSugerido || 0),
                            })
                          }
                        >
                          Usar monto calculado
                        </Button>
                      </div>
                    </div>
                  );
                })()}

                <input
                  type="number"
                  placeholder="Monto de oferta"
                  className="border p-2 rounded w-full"
                  value={montoOferta[pub.id] || ""}
                  onChange={(e) =>
                    setMontoOferta({
                      ...montoOferta,
                      [pub.id]: e.target.value,
                    })
                  }
                />

                <Button
                  disabled={enviando}
                  onClick={() => enviarOferta(pub.id)}
                >
                  {enviando ? "Enviando..." : "Enviar oferta"}
                </Button>
              </div>
            )}
          </Card>
        ))
      )}
    </div>
  );
}
